export default function Hero() {
  return (
    <section id="hero" className="relative w-full min-h-screen flex items-center bg-background-50 overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-br from-primary-50/60 via-background-50 to-accent-50/40"></div>

      <div className="relative w-full px-4 md:px-6 py-28 md:py-32">
        <div className="w-full max-w-[1280px] mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-4 py-1.5 bg-primary-100/80 text-primary-700 text-xs md:text-sm font-semibold rounded-full mb-5 whitespace-nowrap">
              蜜桃系列 · 每日更新 · 高清在线
            </span>

            <h1 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-900 leading-tight mb-4">
              羞羞动漫<span className="hidden sm:inline"> - </span><br className="sm:hidden" />
              动漫美女爆蜜桃系列<br className="hidden sm:inline" />
              高清在线
            </h1>

            <p className="text-base md:text-lg text-primary-500 font-semibold mb-6">
              新番追更 · 高清播放 · 流畅体验
            </p>

            <p className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-[560px] mx-auto lg:mx-0 mb-6">
              羞羞动漫在线蜜桃系列高清完整版，汇聚全网热门动漫美女资源，提供羞羞动漫在线观看、免费播放与新番追更服务。每日更新蜜桃动漫在线新作，覆盖校园、奇幻、恋爱等多类题材，下拉式流畅浏览体验，一网打尽你想要的每一部蜜桃动漫在线佳作。
            </p>

            <p className="text-sm text-foreground-500 leading-relaxed max-w-[560px] mx-auto lg:mx-0 mb-8">
              本站坚持日更节奏，已收录蜜桃动漫在线资源超500部，涵盖羞羞动漫在线观看完整版与羞羞动漫在线高清播放全系列。新番上线48小时内同步更新，在线画质最高支持1080P，确保每一次羞羞动漫在线免费观看都流畅不卡顿。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 md:gap-8 mb-8">
              <div className="flex items-center gap-2 text-sm text-foreground-600">
                <span className="w-2 h-2 rounded-full bg-accent-500"></span>
                <span className="font-semibold text-foreground-800">500+</span>
                <span>部蜜桃在线资源</span>
              </div>
              <div className="flex items-center gap-2 text-sm text-foreground-600">
                <span className="w-2 h-2 rounded-full bg-accent-500"></span>
                <span className="font-semibold text-foreground-800">日更</span>
                <span>新番同步上线</span>
              </div>
              <div className="flex items-center gap-2 text-sm text-foreground-600">
                <span className="w-2 h-2 rounded-full bg-accent-500"></span>
                <span className="font-semibold text-foreground-800">1080P</span>
                <span>高清流畅播放</span>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#index"
                className="inline-flex items-center gap-2 bg-primary-500 hover:bg-primary-600 text-background-50 px-8 py-3.5 rounded-full text-sm md:text-base font-semibold transition-all whitespace-nowrap cursor-pointer"
              >
                <i className="ri-play-circle-line text-lg"></i>
                立即在线观看
              </a>
              <a
                href="#carousel"
                className="inline-flex items-center gap-2 border-2 border-primary-300 text-primary-600 hover:bg-primary-50 px-8 py-3.5 rounded-full text-sm md:text-base font-semibold transition-all whitespace-nowrap cursor-pointer"
              >
                <i className="ri-fire-line text-lg"></i>
                热门专题推荐
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-[480px] lg:max-w-[520px]">
            <div className="relative w-full aspect-[4/5] rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Anime%20style%20illustration%20of%20beautiful%20female%20character%20with%20long%20silky%20hair%20in%20soft%20peach%20and%20pink%20color%20palette%2C%20elegant%20expression%2C%20floating%20cherry%20blossom%20petals%2C%20warm%20golden%20lighting%2C%20dreamy%20atmosphere%2C%20ethereal%20glow%20effect%2C%20semi-transparent%20fabric%20details%2C%20anime%20visual%20novel%20style%20art%2C%20highly%20detailed%20illustration%2C%20soft%20bokeh%20background%2C%20warm%20color%20gradients%2C%20romantic%20and%20charming%20mood&width=1040&height=1300&seq=hero-main-visual&orientation=portrait"
                alt="羞羞动漫蜜桃系列主视觉"
                className="w-full h-full object-cover object-top"
                loading="eager"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-background-950/20 via-transparent to-transparent"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}